import { ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Visit } from 'src/app/admin/models/visit.model';
import { Visitor } from 'src/app/admin/models/visitor';
import { VisitService } from 'src/app/admin/services/visit.service';
import { validateVisit } from 'src/app/utils/formValidators';
import { environment } from 'src/environments/environment';
import * as signalR from "@microsoft/signalr";
import { IonSelect } from '@ionic/angular';
import { IonInput } from '@ionic/angular';
import domtoimage from 'dom-to-image';
import jsPDF from 'jspdf';
import { QRCodeComponent } from 'angularx-qrcode';
import { VisitorChild } from 'src/app/admin/models/visitorChild';
import { ActivatedRoute } from '@angular/router';
import { NotifierService } from 'angular-notifier';

@Component({
  selector: 'app-add-visit-modal',
  templateUrl: './add-visit-modal.component.html',
  styleUrls: ['./add-visit-modal.component.scss'],
})
export class AddVisitModalComponent implements OnInit {
  visit: Visit;
  visitor;
  errMsg = '';
  msg = '';
  apiUrl = environment.apiUrl;
  disableButton = true;
  roomId;
  qrCode = '';
  cardType = 0;
  hours = 0;
  packageTicketType = false;
  buttonPotvrdiClick:boolean=false

  @ViewChild('mySelect') select: IonSelect;

  // eslint-disable-next-line @typescript-eslint/member-ordering
  @ViewChild('myInput') input: IonInput;
  isInputDisabled = false;

  constructor(private modalController: ModalController, private visitService: VisitService,
    private cdRef: ChangeDetectorRef, private notifierService: NotifierService) {
    /*  this.visitor.id = 1 */
  }

  ngOnInit() {
    // TODO: user from AccountService, MM
    let loggedUser = JSON.parse(localStorage.getItem('loggedUser'));
    this.roomId = loggedUser.roomId;
  }

  // eslint-disable-next-line @angular-eslint/use-lifecycle-interface
  ngAfterViewInit() {
    this.select.value = "0";
    this.cdRef.detectChanges();
  }

  onSelectChange() {
    if (this.select.value === '0') {
      this.isInputDisabled = false;
    } else {
      this.isInputDisabled = true;
    }
  }

onAddVisit(event:any){
 this.buttonPotvrdiClick=true
 this.addVisit();
}



  addVisit() {
  //  let codeToSend = this.qrCode;
    let phoneToSend = String(this.visitor.phone);
    let mailToSend = String(this.visitor.email);
    let GratisCheck= this.visitor.gratis
   let GratisToSend:string

   
    console.log("phoneToSend");
    console.log(phoneToSend);

    console.log("mailtoSend");
    console.log(mailToSend);
    if (GratisCheck == true) {
      GratisToSend = "Gratis"
    }
    else {

      GratisToSend = ""

    }
    console.log("GratisToSend",GratisToSend);

    this.errMsg = '';
  
    // Disable button
   // this.qrCode = '';
    this.cardType = this.select.value;
  
    if (this.cardType == 0) {
      this.hours = +this.input.value;
      this.visitService.addVisit(this.visitor, phoneToSend, mailToSend, this.cardType, this.hours, GratisCheck, this.packageTicketType).subscribe((data: ArrayBuffer) => {
        const blob = new Blob([data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = url;
        document.body.appendChild(iframe);
        iframe.contentWindow?.print();
        window.URL.revokeObjectURL(url);
        this.dismissModal();
        },
        err => {
          let errorString = err.error.title.replace(/"/g, '');
          this.notifierService.show({
            message: '' + JSON.stringify(errorString),
            type: 'warning',
          });
          this.errMsg = errorString;
        }
      );
    } else {
      this.visitService.addVisitWithoutHours(this.visitor, phoneToSend, mailToSend, this.cardType, GratisCheck, this.packageTicketType).subscribe((data: ArrayBuffer) => {
        const blob = new Blob([data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = url;
        document.body.appendChild(iframe);
        iframe.contentWindow?.print();
        window.URL.revokeObjectURL(url);
        this.dismissModal();
        },
        err => {
          let errorString = err.error.title.replace(/"/g, '');
          this.notifierService.show({
            message: '' + JSON.stringify(errorString),
            type: 'warning',
          });
          this.errMsg = errorString;
        }
      );
    }
  }
  
  dismissModal() {
    this.modalController.dismiss();

  }


  getFullNameOrSlash(visitor) {
    return visitor ? `${visitor.fullname} ${visitor.birthDate}` : '/';
  }
}
